import React from "react";
import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { DepositResponseItem } from "@api-types/deposit";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { DepositHistoryTableItem } from "@features/payment/deposit/desktop/my-deposits/table";
import { DepositContext } from "@state/context/payment/DepositContext";
import { observer } from "mobx-react";

export default observer(function MyDepositsTable() {
	const { t } = useTranslation("payment");

	const { depositList } = useContext(DepositContext);

	if (depositList == null) {
		return null;
	}

	if (depositList.item.length === 0) {
		return (
			<InfoMessageComponent
				type="note"
				message={t<string>("COMMON.TABLE.EMPTY")}
				addClassName="u-mar--top--med"
			/>
		);
	}

	return (
		<table className="table--primary u-mar--top--med">
			<thead className="table--primary__header table--primary__header--light">
				<tr className="table--primary__header__row">
					<th className="table--primary__header__data">ID</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.AMOUNT")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.METHOD")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.START_DATE")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.END_DATE")}
					</th>
					<th className="table--primary__header__data u-type--center">
						{t<string>("COMMON.TABLE.WALLET")}
					</th>
					<th className="table--primary__header__data">
						{t<string>("COMMON.TABLE.HEADER.STATUS")}
					</th>
				</tr>
			</thead>
			<tbody className="table--primary__body">
				{depositList.item.map(
					(depositHistoryItem: DepositResponseItem) => {
						return (
							<DepositHistoryTableItem
								key={depositHistoryItem.id}
								depositHistoryItem={depositHistoryItem}
							/>
						);
					}
				)}
			</tbody>
		</table>
	);
});
